export default function PageWrapper({ backgroundImage, children }) {
  return (
    <div className="relative min-h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div
        className="fixed inset-0 bg-cover bg-center bg-no-repeat z-0"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      />

      {/* Full-Screen Tint Overlay */}
      <div className="fixed inset-0 bg-black/60 z-[1]" />

      {/* Page Content */}
      <div className="relative z-10 py-10 text-text-dark dark:text-white w-full">
        {children}
      </div>
    </div>
  );
}
